
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80","viewBox":"0 0 96.95 96.95"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5","data-name":"report 3"}},[_c('path',{attrs:{"d":"M32.317 8.086v12.129"}}),_c('path',{attrs:{"data-name":"Vector","d":"M64.633 8.086v12.129M64.948 14.151c13.447.727 20.191 5.856 20.191 24.837v24.963c0 16.639-4.038 24.958-24.23 24.958H36.678c-20.192-.005-24.23-8.324-24.23-24.958V38.988c0-18.981 6.744-24.07 20.192-24.837z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M35.017 60.936a9.17 9.17 0 008.959 9.4h10.128a8.023 8.023 0 007.829-8.192c0-4.923-2.139-6.658-5.327-7.788l-16.262-5.647c-3.188-1.13-5.327-2.865-5.327-7.788a8.023 8.023 0 017.829-8.192h10.128a9.17 9.17 0 018.958 9.4M48.447 27.324v48.424"}})])])
          )
        }
      }
    